import React from "react";
import * as T from "prop-types";

import { isEmpty } from "2g-utils-common";
import { PlaceholderText } from "2g-placeholder";

export function Zakaznik({ val, showPlaceholder }) {
  if (isEmpty(val)) return null;
  return (
    <span className="b2b-RendererCiselnik b2b-RendererCiselnik--uzivatel">
      <span className="b2b-RendererCiselnik-nazev">
        {showPlaceholder ? (
          <PlaceholderText>Lumír Gago</PlaceholderText>
        ) : (
          `${val.jmeno} ${val.prijmeni}`
        )}
      </span>
    </span>
  );
}

Zakaznik.propTypes = {
  val: T.shape({ jmeno: T.string, prijmeni: T.string }),
  showPlaceholder: T.bool
};

export default React.memo(Zakaznik);
